import { useCallback, useEffect, useRef, useState } from "react";
import { EMPTY, Observable, Subscription, catchError, finalize, take } from "rxjs";
import HttpService from "@core/services/http/http.service";

/**
 * Thao tác trên 1 máy (bật, tắt, đổi đường truyền, IP xoay, đổi mật khẩu…): chỉ nút vừa bấm xoay, không che cả trang.
 * run(key, make, onDone): đánh dấu key đang chạy, tạo request bằng HttpService.local (không có lớp Loading),
 * xong (thành công hoặc lỗi) thì bỏ đánh dấu. Lỗi đã được HttpService báo bằng toast nên ở đây bỏ qua.
 * busy[key] dùng để hiện spinner và khoá nút; key thường là "<thao tác>:<id máy>".
 */
export default function useBusy() {
  const [busy, setBusy] = useState<Record<string, boolean>>({});
  const mounted = useRef(true);

  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );

  const run = useCallback(
    <T,>(key: string, make: () => Observable<T>, onDone?: (data: T) => void): Subscription => {
      setBusy((pre) => ({ ...pre, [key]: true }));

      const done = () => {
        if (!mounted.current) return;

        setBusy((pre) => {
          if (!pre[key]) return pre;

          const next = { ...pre };

          delete next[key];

          return next;
        });
      };

      return HttpService.local(make)
        .pipe(
          take(1),
          finalize(done),
          catchError(() => EMPTY)
        )
        .subscribe((data) => onDone?.(data));
    },
    []
  );

  return { busy, run };
}
